// Corresponds to the feature name in the database - added by the admin
export const MEMBERSHIP_FEATURE = "Memberships";
export const MEMBERSHIP_FEATURE_KEY = "memberships";
export const MEMBERSHIP_NAVIGATION_IND = 5;
export const SERVICE_REPORTING_FEATURE = "Services";
export const SERVICE_REPORTING_FEATURE_KEY = "services";
export const SERVICE_REPORTING_IND = 7;
export const TRANSACTION_REPORTING_FEATURE_KEY = "transaction-reporting";
export const CHARTING_NAVIGATION_KEY_APP_VIEW = "charting";
export const QUESTIONNAIRES_NAVIGATION_KEY_APP_VIEW = "questionnaires";
export const MY_PRACTICE_NAVIGATION_KEY_APP_VIEW = "my-practice";
export const LOYALTY_NAVIGATION_KEY_APP_VIEW = "loyalty-program";
export const MARKETING_NAVIGATION_KEY_APP_VIEW = "marketing";
export const SPECIALS_NAVIGATION_KEY_APP_VIEW = "specials";
export const GIFT_CARDS_NAVIGATION_KEY_APP_VIEW = "gift-cards";
// Change path to key when agency menu key issue is resolved
export const CHARTING_NAVIGATION_PATH_AGENCY_VIEW = "/agency/charting";
export const QUESTIONNAIRES_NAVIGATION_PATH_AGENCY_VIEW =
  "/agency/questionnaires";

export const DAILY_CADENCE_FEATURE = "Membership Daily Cadence";

export const FEATURE_LIST = {
  MEMBERSHIPS: "Memberships",
  DAILY_CADENCE_FEATURE: "Membership Daily Cadence",
  SERVICE_REPORTING: "Service reporting statistics",
  CHARTING: "Charting",
  QUESTIONNAIRES: "Consent Forms",
  STRIPE_CONNECT: "Stripe connect",
  REDESIGN_SINGLE_CONTACT_PAGE: "Redesign Single Contact Page",
  LOYALTY: "Loyalty",
  SPECIALS: "Specials",
  GIFT_CARDS: "Gift Cards",
  INVENTORY: "Inventory",
  NEW_INBOX: "New Inbox",
};
